// Utils
import areDraggedItemsLegacyTaskListsWithoutHeadings from '../task/areDraggedItemsLegacyTaskListsWithoutHeadings';
import { isTask } from '../../../../common/elements/utils/elementTypeUtils';

export default ({ props, monitor }) => {
    const item = monitor.getItem();
    return (
        (item.draggedElements && item.draggedElements.every(isTask)) ||
        areDraggedItemsLegacyTaskListsWithoutHeadings(props, monitor)
    );
};
